import React, {useState} from 'react';
import BodyGraphicsSelect from "./BodyGraphicsSelect";
import {getByModuleId, MODULE_BODY_GRAPHICS} from "../Modules";
import Breadcrumb from "../../Breadcrumb";
import appUserRoutes from "../../../appUserRoutes";
import {TAB_MODULES} from "../../../views/UserViews/TecRmi/MainView";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const BodyGraphics = props => {
  const { ident, showType } = useTecRmi()
  const [crumbs, setCrumbs] = useState([])

  return (
    <div>
      <Breadcrumb
        crumbs={[
          {
            name: <i className="fas fa-chevron-circle-left" />,
            path: appUserRoutes.tecRmi.tab(ident, TAB_MODULES),
          },
          {
            name: getByModuleId(MODULE_BODY_GRAPHICS, 'name'),
            path: appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName')),
          },
          ...crumbs
        ]}
      />

      <BodyGraphicsSelect
        svgStyled={true}
        params={props?.params}
        onCrumbsUpdated={crumbs => setCrumbs([...crumbs])}
      />
    </div>
  );
};

BodyGraphics.propTypes = {

};

export default BodyGraphics;